import { motion } from "motion/react";
import { getPricingForCity } from "@/config/city-pricing";

export interface ZonePricingProps {
  cityName: string;
  slug: string;
}

export default function ZonePricing({ cityName, slug }: ZonePricingProps) {
  const prices = getPricingForCity(slug);

  const items = [
    { service: "Cambio de cinta persiana", price: `${prices.cinta}€` },
    { service: "Reparación motor persiana", price: `${prices.motorReparar}€` },
    { service: "Sustitución motor", price: `${prices.motorSustituir}€` },
    { service: "Cambiar lamas (por lama)", price: `${prices.lamasPorLama}€` },
    { service: "Desplazamiento", price: prices.desplazamiento },
  ];

  return (
    <section className="bg-surface-alt py-16 md:py-24">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4 text-center">
            Precios orientativos en {cityName}
          </h2>
          <div className="w-10 h-1 bg-primary mx-auto rounded-full mb-4"></div>
          <p className="font-body text-base text-text-secondary text-center mb-10 max-w-2xl mx-auto">
            Precios transparentes y sin sorpresas. Sin coste de desplazamiento dentro de {cityName}.
          </p>

          <div className="max-w-2xl mx-auto bg-white rounded-2xl border border-border overflow-hidden shadow-sm">
            {items.map((item, i) => (
              <div
                key={item.service}
                className={`flex items-center justify-between px-6 py-4 ${
                  i !== items.length - 1 ? "border-b border-border/60" : ""
                }`}
              >
                <span className="font-body text-sm md:text-base text-text-primary">
                  {item.service}
                </span>
                <span className="font-heading font-bold text-base md:text-lg text-primary whitespace-nowrap ml-4">
                  {item.price}
                </span>
              </div>
            ))}
          </div>
          <p className="text-xs text-gray-500 mt-3 text-center max-w-2xl mx-auto">
            {prices.note} Presupuesto exacto sin compromiso tras visita técnica.
          </p>
          <p className="font-body text-sm text-text-secondary text-center mt-6 max-w-2xl mx-auto">
            Los precios finales dependen de las dimensiones y el estado de la instalación. Te damos presupuesto exacto sin compromiso.
          </p>
        </motion.div>
      </div>
    </section>
  );
}